import { useSelector } from 'react-redux';
import { elitetutorSlice } from 'logic/store/elitetutor/elitetutor.slice';
import { useAnyInProgress } from 'logic/store/tracker/tracker.hooks';
import { getElitePaymentConfig } from 'logic/store/elitetutor/elitetutor.selectors';

export const useMyPricingKillSwitch = () => {
  const elitePaymentConfig = useSelector(getElitePaymentConfig);
  const inProgress = useAnyInProgress([
    elitetutorSlice.actions.getElitePaymentConfig,
    elitetutorSlice.actions.getElitePaymentSeekerInfo,
    elitetutorSlice.actions.subscriptionChangePreview,
  ]);

  //killswitch || because of weird caching ignore undefined/null
  const killSwitch = !inProgress && (!elitePaymentConfig || elitePaymentConfig.active === false);

  return { killSwitch };
};
